import React, { useMemo } from 'react';
import { useProducts } from '../../useProducts';
import { useSiteSettings } from '../../SiteSettingsContext';
import { resolveHomeShelfProducts } from '../../storefront/homeProductShelves';
import ProductShelfSection from '../ProductShelfSection';
import ProductShelfCard from '../ProductShelfCard';
import CatalogGridSkeleton from '../../catalog/CatalogGridSkeleton';

export default function HomeProductShelves() {
  const { products, loading } = useProducts();
  const { settings: site } = useSiteSettings();
  const store = site.store_copy || {};

  const shelves = useMemo(() => {
    const raw = Array.isArray(store.home_product_shelves) ? store.home_product_shelves : [];
    return raw
      .filter((s) => s?.enabled !== false)
      .map((s) => ({
        ...s,
        products: resolveHomeShelfProducts(products, s),
      }))
      .filter((s) => s.products.length > 0);
  }, [products, store.home_product_shelves]);

  if (!shelves.length) {
    if (loading) {
      return (
        <section className="home-config-shelves home-config-shelves--loading">
          <div className="container store-page__container">
            <CatalogGridSkeleton count={4} />
          </div>
        </section>
      );
    }
    return null;
  }

  return (
    <>
      {shelves.map((shelf) => (
        <ProductShelfSection
          key={`${shelf.category_slug}-${shelf.title}`}
          title={shelf.title}
          actionHref={shelf.action_href}
          actionLabel={shelf.action_label}
          layout="scroll"
          className="home-config-shelf"
          ariaLabel={shelf.title}
        >
          {shelf.products.map((p) => (
            <div className="product-shelf__cell" key={`${p.category}-${p.id}`}>
              <ProductShelfCard product={p} categorySlug={p.category} />
            </div>
          ))}
        </ProductShelfSection>
      ))}
    </>
  );
}
